var exports = {
  "kL": "DirectCallLobbyBottomSheet.module__container___ZGxFWG",
  "v0": "DirectCallLobbyBottomSheet.module__buttonRow___ZGxFWG",
  "Ij": "DirectCallLobbyBottomSheet.module__fullWidth___ZGxFWG",
  "jf": "DirectCallLobbyBottomSheet.module__statusRow___ZGxFWG",
  "Rh": "DirectCallLobbyBottomSheet.module__statusLabel___ZGxFWG",
  "ht": "DirectCallLobbyBottomSheet.module__callPreview___ZGxFWG",
};

module.exports = exports;
